"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var FormHelperText_1 = require("@material-ui/core/FormHelperText");
var Grid_1 = require("@material-ui/core/Grid");
var TextField_1 = require("@material-ui/core/TextField");
var withStyles_1 = require("@material-ui/styles/withStyles");
var Env_1 = require("src/Env");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var Forms_1 = require("src/Forms");
var Snackbar_1 = require("src/Snackbar");
var ResendConfirmation = /** @class */ (function (_super) {
    __extends(ResendConfirmation, _super);
    function ResendConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emailInput = React.createRef();
        /**
         * Handle form submission, call provided listener
         */
        _this.onSubmit = function (e) {
            e.preventDefault();
            if (_this.emailInput.current === null) {
                return _this.props.displayMessage('Email Input ref associate with form field', 'error');
            }
            _this.props.onSubmit(_this.emailInput.current.value);
        };
        /**
         * Get the error message for the field
         */
        _this.errorMessageForField = function (fieldName) {
            return _this.props.response && _this.props.response[fieldName];
        };
        /**
         * Returns the class name to be applied to a field
         */
        _this.classForField = function (fieldName) {
            return _this.errorMessageForField(fieldName) ?
                _this.props.classes.errorInput :
                _this.props.classes.primaryInput;
        };
        /**
         * Return the error message for a given fieldName
         */
        _this.errorForField = function (fieldName) {
            var errorMessage = _this.errorMessageForField(fieldName);
            if (errorMessage === undefined) {
                return null;
            }
            else {
                return React.createElement(FormHelperText_1.default, { error: true }, errorMessage);
            }
        };
        return _this;
    }
    ResendConfirmation.prototype.render = function () {
        var _a = this.props, classes = _a.classes, status = _a.status, response = _a.response;
        var isDisabled = status === 'waiting';
        console.log(response);
        return (React.createElement("form", { onSubmit: this.onSubmit },
            React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.topGridItem },
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement("img", { src: Env_1.ASSET_ROOT + "Logo-Signin.png", alt: "Rowan Technology" })),
                response && response.emailError && React.createElement(Snackbar_1.CustomSnackbar, { message: response.emailError, variant: "error" }),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(TextField_1.default, { disabled: isDisabled, className: classes.fullWidth, InputProps: { className: this.classForField('emailError') }, variant: "filled", margin: "dense", label: "email", required: true, type: "email", inputProps: { ref: this.emailInput } }),
                    this.errorForField('emailError')),
                React.createElement(Grid_1.default, { item: true, className: classes.topGridItem },
                    React.createElement(Button_1.default, { disabled: isDisabled, className: classes.fullWidth, variant: "contained", color: "primary", type: "submit", size: "large" }, "resend")))));
    };
    return ResendConfirmation;
}(React.Component));
exports.default = withStyles_1.default(Forms_1.styles)(ErrorBoundary_1.withDisplayMessage(ResendConfirmation));
